import { render, staticRenderFns } from "./SupplierSelects.vue?vue&type=template&id=672a3d1b&"
import script from "./SupplierSelects.vue?vue&type=script&lang=js&"
export * from "./SupplierSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports